import axiosInstance from '../../core/axiosConfig';

export class OrderService {
  cancelOrder = async (orderId: number) => {
    await axiosInstance.patch(`/order/cancel?orderId=${orderId}`);
  };

  confirmOrder = async (orderId: number, estimatedTime: string) => {
    console.log(estimatedTime);
    await axiosInstance.patch(`/order/confirm?orderId=${orderId}&estimatedTime=${estimatedTime}`);
  };

  markOrderAsReady = async (orderId: number) => {
    await axiosInstance.patch(`/order/ready-for-pickup?orderId=${orderId}`);
  };

  markOrderAsPickedUp = async (orderId: number) => {
    await axiosInstance.patch(`/order/picked-up?orderId=${orderId}`);
  };
}
